export const apiEndpoint = process.env.API_ENDPOINT;
